import React from 'react'
import styled from 'styled-components'
import shortid from 'shortid'
import media from '../../../styles/media'
import CountUp from '../../../components/countup/countup'

const Container = styled.div`
  background-color: #40b4e4;
  display: none;
  ${media.md`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 50px;
  `};
`

const CountUpContainer = styled.div`
  padding: 20px 90px;
`

const BlueCountUp = props => {
  const countsup = props.counters.map(counter => (
    <CountUpContainer key={shortid.generate()}>
      <CountUp start={counter.start} end={counter.end} title={counter.title} />
    </CountUpContainer>
  ))

  return <Container {...props}>{countsup}</Container>
}

export default BlueCountUp



// WEBPACK FOOTER //
// ./src/components/section/countup/countup.js